module.exports = __webpack_public_path__ + "static/media/Grid.761c2a8b.svg";